import React from "react";
import "../../css/Home/About.css";
import AboutSection from "./AboutSection";
import "../../css/MSAProgramme/About.css";

const expectationsParagraph = [
  {
    content:
      "The MSA Programme aims to develop and train students to prepare them for work placement with some of Auckland's leading IT companies. This is an opportunity for students to get a step ahead of their peers, build connections with the industry, and also show their capability by working on real innovative project. ",
  },
  {
    content:
      "Students taking part in the Microsoft Student Accelerator Programme come from a variety of backgrounds and have diverse skills. MSA students have been learning C# and Microsoft technology through the Microsoft Learn, in-person workshops and online training provided by our Student Partners.",
  },
  {
    content:
      "The Registration for 2025 opens from 31/03/2025 to 18/05/2025"
  },
  // {
  //   content:
  //     "In 2023, we trained over 300 students through the programme. Over 90% of the students who passes MSA 2023 received a paid work placement over the summer and were placed with our employer partners.",
  // },
];

function About() {
  return (
    <div className="about bg-light-gray container-fluid">
      <div className="py-5">
        <AboutSection
          title="The MSA Programme"
          paragraphs={expectationsParagraph}
        />
        <a href="https://forms.office.com/r/wyxaGwABEM">
          <button className="get-started-button">Register Now!</button>
        </a>
      </div>
    </div>
  );
}

export default About;
